export enum Permission {
  Admin = 'admin_panel.legacy_permission',
  StorefrontShortcutsBarModify = 'storefront_shortcuts_bar.modify',
  StorefrontShortcutsBarView = 'storefront_shortcuts_bar.view',
}
